import http from '../services/http';
import { typeAs } from '../services/utils';

export default {
  namespaced: true,

  state: {
    career: null,
    teamDetail: null,
  },

  mutations: {
    INIT_CAREER(state) {
      state.career = {
        title: '',
        subtitle: '',
        background: '',
        call_to_action: '',
        url: '',
        cultures: [],
        teams: [],
        job: {
          title: '',
          subtitle: '',
          background: '',
          call_to_action: '',
          url: '',
        },
        video_rotates: [],
      };
    },
    CLEAR_CAREER(state) {
      state.career = null;
      state.teamDetail = null;
    },
    SET_CAREER(state, data) {
      state.career = data;
    },
    INIT_TEAM_DETAIL(state, detail) {
      state.teamDetail = detail;
    },
    SET_TEAM_DETAIL(state, detail) {
      if (!state.career.teams) {
        state.career.teams = [];
      }

      if (detail.id) {
        const index = state.career.teams.map((i) => i.id).indexOf(detail.id);
        state.career.teams[index] = detail;
      } else {
        state.career.teams.push(detail);
      }
    },
  },

  actions: {
    init({ commit }) {
      commit('INIT_CAREER');
    },

    clear({ commit }) {
      commit('CLEAR_CAREER');
    },

    setCareer({ commit }, data) {
      commit('SET_CAREER', data);
    },

    initTeamDetail({ commit }, detail) {
      commit('INIT_TEAM_DETAIL', detail);
    },

    setTeamDetail({ commit }, detail) {
      commit('SET_TEAM_DETAIL', detail);
    },

    find({ commit }) {
      return http('/career')
        .then((response) => response.body)
        .then(typeAs('Csr'))
        .then((response) => {
          commit('SET_CAREER', response);
          return response;
        });
    },

    deleteTeam(_, id) {
      const request = http(`/career/teams/${id}`, { method: 'DELETE' });

      return request.then((response) => response.body);
    },

    save(_, data) {
      const request = http('/career', { method: 'PUT', data });

      return request.then((response) => response.body);
    },

    saveTeam(_, data) {
      const request = http('/career/teams', { method: 'POST', data });

      return request.then((response) => response.body);
    },
  },
};
